export const EQUIPMENT = {
  HELM: "EQUIPMENT_HELM",
  CHEST: {
    BODY: {
      UNTUCKED: "EQUIPMENT_CHEST_BODY_UNTUCKED",
      TUCKED: "EQUIPMENT_CHEST_BODY_TUCKED" // may not need
    },
    OFFHAND: {
      ONE_HANDED: "EQUIPMENT_OFFHAND_ONE_HANDED",
      TWO_HANDED: "EQUIPMENT_OFFHAND_TWO_HANDED",
      CROSSBOW_ONE_HANDED: "EQUIPMENT_OFFHAND_CROSSBOW_ONE_HANDED",
      CROSSBOW_TWO_HANDED: "EQUIPMENT_OFFHAND_CROSSBOW_TWO_HANDED",
      THROWING: "EQUIPMENT_OFFHAND_THROWING"
    },
    MAINHAND: {
      ONE_HANDED: "EQUIPMENT_MAINHAND_ONE_HANDED",
      TWO_HANDED: "EQUIPMENT_MAINHAND_TWO_HANDED",
      CROSSBOW_ONE_HANDED: "EQUIPMENT_MAINHAND_CROSSBOW_ONE_HANDED",
      CROSSBOW_TWO_HANDED: "EQUIPMENT_MAINHAND_CROSSBOW_TWO_HANDED",
      THROWING: "EQUIPMENT_MAINHAND_THROWING"
    },
  },
  OFFHAND: {
    ONE_HANDED: {
      CROSSBOW: {
        UNDER:  "EQUIPMENT_OFFHAND_CROSSBOW_ONE_HANDED_UNDER",
        OVER: 'EQUIPMENT_OFFHAND_CROSSBOW_ONE_HANDED_OVER'
      },
      SHIELD: {
        UNDER: "EQUIPMENT_OFFHAND_SHIELD_UNDER"
      }
    }
  },
  MAINHAND: {
    ONE_HANDED: {
      DEFAULT: {
        UNDER: "EQUIPMENT_MAINHAND_ONE_HANDED_UNDER"
      },
      CROSSBOW: {
        UNDER: 'EQUIPMENT_MAINHAND_CROSSBOW_ONE_HANDED_UNDER',
        OVER: 'EQUIPMENT_MAINHAND_CROSSBOW_ONE_HANDED_OVER'
      }
    },
    TWO_HANDED: {
      UNDER: "EQUIPMENT_MAINHAND_CROSSBOW_TWO_HANDED_UNDER",
      OVER: "EQUIPMENT_MAINHAND_CROSSBOW_TWO_HANDED_OVER"
    }
  },
  GLOVES: {
    MAINHAND: {
      ONE_HANDED: {
        UNDER: "EQUIPMENT_GLOVES_MAINHAND_ONE_HANDED_UNDER",
        OVER: "EQUIPMENT_GLOVES_MAINHAND_ONE_HANDED_OVER"
      },
      CROSSBOW: {
        UNDER: "EQUIPMENT_GLOVES_MAINHAND_CROSSBOW_UNDER",
        OVER: "EQUIPMENT_GLOVES_MAINHAND_CROSSBOW_OVER"
      },
      THROWING: {
        UNDER: "EQUIPMENT_GLOVES_MAINHAND_THROWING_UNDER",
        OVER: "EQUIPMENT_GLOVES_MAINHAND_THROWING_OVER"
      },
      TWO_HANDED: {
        UNDER: "EQUIPMENT_GLOVES_MAINHAND_TWO_HANDED_UNDER",
        OVER: "EQUIPMENT_GLOVES_MAINHAND_TWO_HANDED_OVER"
      },
      TWO_HANDED_CROSSBOW: {
        UNDER: "EQUIPMENT_GLOVES_MAINHAND_TWO_HANDED_CROSSBOW_UNDER",
        OVER: "EQUIPMENT_GLOVES_MAINHAND_TWO_HANDED_CROSSBOW_OVER"
      }
    },
    OFFHAND: {
      ONE_HANDED: {
        UNDER: "EQUIPMENT_GLOVES_OFFHAND_ONE_HANDED_UNDER",
        OVER: "EQUIPMENT_GLOVES_OFFHAND_ONE_HANDED_OVER"
      },
      CROSSBOW: {
        UNDER: "EQUIPMENT_GLOVES_OFFHAND_CROSSBOW_UNDER",
        OVER: "EQUIPMENT_GLOVES_OFFHAND_CROSSBOW_OVER"
      },
      THROWING: {
        UNDER: "EQUIPMENT_GLOVES_OFFHAND_THROWING_UNDER",
        OVER: "EQUIPMENT_GLOVES_OFFHAND_THROWING_OVER"
      },
      TWO_HANDED: {
        UNDER: "EQUIPMENT_GLOVES_OFFHAND_TWO_HANDED_UNDER",
        OVER: "EQUIPMENT_GLOVES_OFFHAND_TWO_HANDED_OVER"
      },
      TWO_HANDED_CROSSBOW: {
        UNDER: "EQUIPMENT_GLOVES_OFFHAND_TWO_HANDED_CROSSBOW_UNDER",
        OVER: "EQUIPMENT_GLOVES_OFFHAND_TWO_HANDED_CROSSBOW_OVER"
      }
    }
  },
  PANTS: {
    UNTUCKED: "EQUIPMENT_PANTS_UNTUCKED",
    TUCKED: "EQUIPMENT_PANTS_TUCKED" // may not need
  },
  BOOTS: {
    TUCKED: "EQUIPMENT_BOOTS_TUCKED",
    UNTUCKED: "EQUIPMENT_BOOTS_UNTUCKED" // may not need
  },
} as const;
